import { useCallback } from 'react';
import { usePlayerEvent } from './use-player-event';
export const useOnDataPartLoaded = (player, onLoaded) => {
  const handleLoadedData = useCallback(() => {
    if (onLoaded && player) {
      onLoaded(player);
    }
  }, [onLoaded, player]);
  usePlayerEvent(player, 'progress', handleLoadedData);
};